import { APITypesV2 } from "@cur8/api-client";
import type { Visit } from "@cur8/rich-entity";
import type { useLatestConsentsQuery } from "hooks/queries/usePatientConsentsQuery";

type LatestConsents = ReturnType<typeof useLatestConsentsQuery>["data"];

// Whether a visit needs a study-consent countersign before room assignment.
// Shared between PreferredNameView (QR/manual flow) and
// ImmediateRiskAssessmentView (its Active Sessions fallback).
export function shouldCounterSignBeforeRoom({
  visitConsents,
  latestConsents,
}: {
  visitConsents: Visit["consents"];
  latestConsents: LatestConsents;
}): boolean {
  const hasStudiesOnVisit = visitConsents?.some(
    (consent) =>
      consent.consentType === APITypesV2.ConsentType.Study &&
      consent.displayStages.includes(APITypesV2.ConsentDisplayStage.DuringVisit)
  );
  const hasCounterSignRequiredConsents = latestConsents?.some(
    (consent) => consent.relevantSignature.counterSignatureRequired === true
  );
  return Boolean(hasStudiesOnVisit && hasCounterSignRequiredConsents);
}
